export const load = (name, defaultValue) => {
    const tmp = window.localStorage.getItem(name)
    return tmp ? tmp : defaultValue
}

export const save = (name, value) => {
    window.localStorage.setItem(name, value)
}
